// extracted by mini-css-extract-plugin
export default {"smallCheckWrapper":"m9gh2"};